/**
 * Password Strength Validation and Requirements Helper
 */

export const PASSWORD_REQUIREMENTS_LIST = [
  "Between 8 and 14 characters long",
  "At least one uppercase letter (A-Z)",
  "At least one lowercase letter (a-z)",
  "At least one number (0-9)",
  "At least one special character (such as !, @, #, $, %, ^, &, *, etc.)",
  "No spaces allowed",
];

export const validatePassword = (password) => {
  if (!password || typeof password !== "string") {
    return {
      isValid: false,
      errors: ["Password is required"],
      message: "Password is required.",
      htmlMessage: "<p>Password is required.</p>",
    };
  }

  const errors = [];
  if (password.length < 8 || password.length > 14) {
    errors.push("Must be between 8 and 14 characters long");
  }
  if (/\s/.test(password)) {
    errors.push("Must not contain any spaces");
  }
  if (!/[A-Z]/.test(password)) {
    errors.push("Must include at least one uppercase letter (A-Z)");
  }
  if (!/[a-z]/.test(password)) {
    errors.push("Must include at least one lowercase letter (a-z)");
  }
  if (!/[0-9]/.test(password)) {
    errors.push("Must include at least one number (0-9)");
  }
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/.test(password)) {
    errors.push(
      "Must include at least one special character (such as !, @, #, $, %, etc.)"
    );
  }

  if (errors.length > 0) {
    return {
      isValid: false,
      errors,
      message: `A strong password must meet the following requirements:\n• ${errors.join(
        "\n• "
      )}`,
      htmlMessage: `
        <div style="text-align: left; font-size: 13px;">
          <p style="margin-bottom: 8px; font-weight: 600; color: #1e293b;">A strong password must meet the following requirements:</p>
          <ul style="padding-left: 20px; margin: 0; color: #475569; line-height: 1.6;">
            ${errors.map((err) => `<li>${err}</li>`).join("")}
          </ul>
        </div>
      `,
    };
  }

  return { isValid: true, errors: [], message: "", htmlMessage: "" };
};
